import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { PIXI } from '@colonist/pixi';
import { GameAction } from '@colonist/game-base-types';
import { TextView } from '../../ui_canvas_engine/TextView.ts';
import { GameFont } from '../../GameFont.ts';
import { UIGameFlickerAnimation } from '../../ui_canvas_engine/animation/UIGameFlickerAnimation.ts';
import { SectionBgAdaptiveView } from '../../ui_canvas_engine/SectionBgViewAdaptive.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { Sprites } from '../UIGameImageDictionary.ts';
import { EnumUtils } from '@colonist/utils';
import { GameColor } from '@colonist/ui-game';
import { TradeValidator } from '@colonist/game-mechanic-validators';
import { CardEnum, TradeResponseStatus } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
export class UIGameBeginnerModeGuideBubble {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.NewTradeOfferReceived:
                this.onTradeOfferReceived(data);
                break;
            case UIGameEventEnums.RemoveTradeOffer:
                this.ongoingTradeExists = false;
                break;
            case UIGameEventEnums.BeginnerModeInteractWithGuide:
                this.onInteractWithGuide();
                break;
            case UIGameEventEnums.BeginnerModeForceOpenGuideBubble:
                this.forceOpenOrHighlightGuideBubble(data);
                break;
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            case UIGameEventEnums.PlayerControllerStateUpdated:
                if (!this.isWelcomeAction()) this.hide();
                break;
            default:
                break;
        }
    }
    drawBeginnerModeGuideBubble(viewToPlaceNear) {
        const itemSize = this.uiGameManager.canvasController.itemSize;
        this.drawBackground(viewToPlaceNear, itemSize);
        this.drawBeginnerModeGuideBubblePointer(itemSize);
    }
    drawBackground(viewToPlaceNear, itemSize) {
        const guideViewX = viewToPlaceNear.x;
        const guideViewY = viewToPlaceNear.y - itemSize * 1.4;
        this.guideBubbleView = new SectionBgAdaptiveView();
        this.guideBubbleView.x = guideViewX;
        this.guideBubbleView.y = guideViewY;
        this.guideBubbleView.zIndex = this.uiGameManager.mapController.mapView.layers.robber;
    }
    drawBeginnerModeGuideBubblePointer(itemSize) {
        const margin = this.uiGameManager.canvasController.margin / 3;
        const outlineAlpha = 0.2;
        const triangleX1 = itemSize * 0.4;
        const triangleX2 = itemSize * 0.7;
        const triangleY1 = this.guideBubbleView.height - margin;
        const triangleY2 = triangleY1 + itemSize * 0.2;
        this.guideBubbleViewPointer = new PIXI.Graphics();
        this.guideBubbleViewPointer.beginFill(GameColor.getColorHexValue(GameColor.Color.Gray0));
        this.guideBubbleViewPointer.lineStyle(margin, undefined, outlineAlpha);
        this.guideBubbleViewPointer.moveTo(triangleX1, triangleY1);
        this.guideBubbleViewPointer.lineTo(triangleX2, triangleY1);
        this.guideBubbleViewPointer.lineTo(triangleX1, triangleY2);
        this.guideBubbleViewPointer.lineTo(triangleX1, triangleY1);
        this.guideBubbleViewPointer.endFill();
        this.parentContainer.addChild(this.guideBubbleViewPointer);
        this.guideBubbleViewPointer.zIndex = this.uiGameManager.mapController.mapView.layers.robber;
        this.guideBubbleViewPointer.x = this.guideBubbleView.x;
        this.guideBubbleViewPointer.y = this.guideBubbleView.y + itemSize * 1.2;
    }
    onInteractWithGuide() {
        if (this.isWelcomeAction()) return this.endWelcomeOnInteraction();
        this.backgroundClickAmount += 1;
        if (this.backgroundClickAmount < this.BACKGROUND_CLICK_AMOUNT_TO_SHOW_GUIDE) return;
        this.forceOpenOrHighlightGuideBubble();
    }
    isWelcomeAction() {
        var _this_currentBeginnerModeAction;
        return ((_this_currentBeginnerModeAction = this.currentBeginnerModeAction) === null || _this_currentBeginnerModeAction === void 0 ? void 0 : _this_currentBeginnerModeAction.type) == GameAction.SkippedWelcome;
    }
    endWelcomeOnInteraction() {
        this.hide();
    }
    forceOpenOrHighlightGuideBubble(forcedBubbleText) {
        if (forcedBubbleText != undefined) this.currentBeginnerModeAction.guideText = forcedBubbleText;
        if (this.shownTranslationObject != this.currentBeginnerModeAction.guideText) this.updateGuideBubbleText();
        const isGuideBubbleVisible = this.guideBubbleView.parent != undefined;
        if (isGuideBubbleVisible) {
            this.animate();
        } else {
            this.show();
        }
    }
    onBeginnerModeActionUpdate(data) {
        this.currentBeginnerModeAction = data;
        this.backgroundClickAmount = 0;
        if (!this.isWelcomeAction()) return this.hide();
        this.updateGuideBubbleText();
        this.show();
    }
    drawGuideBubbleTextView() {
        var _this_guideTextView;
        const itemSize = this.uiGameManager.canvasController.itemSize;
        (_this_guideTextView = this.guideTextView) === null || _this_guideTextView === void 0 ? void 0 : _this_guideTextView.destroy();
        const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp;
        const width = itemSize * (isMobile ? 4.2 : 1.45);
        const height = itemSize * (isMobile ? 4 : 1.1);
        const fontSize = isMobile ? GameFont.Size.XXL : GameFont.Size.L;
        this.guideTextView = new TextView(this.currentBeginnerModeAction.guideText, 0, 0, width, height, this.guideBubbleView, fontSize, GameColor.getColor(GameColor.Color.White));
    }
    drawBackgroundAroundText() {
        const itemSize = this.uiGameManager.canvasController.itemSize;
        const horizontalBuffer = itemSize * 0.4;
        const verticalBuffer = itemSize * 0.2;
        const cornerRadius = 30;
        this.guideBubbleView.drawTextureBgAroundContent(horizontalBuffer, verticalBuffer, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section_dark), cornerRadius);
        this.guideBubbleView.y = this.guideBubbleViewPointer.y - this.guideBubbleView.height;
        this.centerGuideTextView();
    }
    updateGuideBubbleText() {
        if (this.guideTextView == undefined) this.drawGuideBubbleTextView();
        this.shownTranslationObject = this.getTranslationObjectForGuideBubble();
        this.guideTextView.setText(this.shownTranslationObject);
        this.drawBackgroundAroundText();
    }
    getTranslationObjectForGuideBubble() {
        if (this.isWelcomeAction()) return this.currentBeginnerModeAction.guideText;
        if (this.uiGameManager.gameController.isMyTurn) return this.currentBeginnerModeAction.guideText;
        const notYourTurnText = this.getTextForWhenNotYourTurn();
        return notYourTurnText;
    }
    centerGuideTextView() {
        this.guideTextView.centerXInParent();
        this.guideTextView.y = (this.guideBubbleView.height - this.guideTextView.height) / 2;
    }
    hide() {
        if (this.guideBubbleView.parent != undefined) this.guideBubbleView.parent.removeChild(this.guideBubbleView);
        if (this.guideBubbleViewPointer.parent != undefined) this.guideBubbleViewPointer.parent.removeChild(this.guideBubbleViewPointer);
    }
    show() {
        if (this.guideBubbleView.parent == undefined) this.parentContainer.addChild(this.guideBubbleView);
        if (this.guideBubbleViewPointer.parent == undefined) this.parentContainer.addChild(this.guideBubbleViewPointer);
    }
    animate() {
        new UIGameFlickerAnimation(this.guideBubbleView).start();
        new UIGameFlickerAnimation(this.guideBubbleViewPointer).start();
    }
    onTradeOfferReceived(tradeId) {
        const tradeState = this.uiGameManager.gameController.tradeState.activeOffers[tradeId];
        if (tradeState == undefined) return;
        const currentTurnPlayerColors = this.uiGameManager.gameController.currentStateValidator.currentTurnPlayers;
        const playerStates = this.uiGameManager.gameController.getPlayerValidators();
        const embargoState = this.uiGameManager.gameController.tradeState.embargoState;
        const tradeStateController = new TradeValidator(tradeState, currentTurnPlayerColors, playerStates, embargoState);
        this.ongoingTradeExists = true;
        const shouldAcceptTrade = tradeState.forcedResponse == TradeResponseStatus.Accepted;
        const receivingResources = tradeStateController.getReceivingResources(this.uiGameManager.gameController.myColor);
        const resourceName = EnumUtils.getEnumKey(receivingResources[0], CardEnum);
        this.receivingResourceName = shouldAcceptTrade ? resourceName : undefined;
    }
    getTextForWhenNotYourTurn() {
        const notYourTurnText = {
            key: 'strings:game.errors.notYourTurn'
        };
        const shouldAcceptTrade = this.receivingResourceName != undefined;
        const translationForAcceptTrade = {
            key: 'strings:game.beginnerMode.acceptTrade',
            options: {
                resource: this.receivingResourceName
            }
        };
        const translationForRejectTrade = {
            key: 'strings:game.beginnerMode.doNotAcceptTrade'
        };
        const respondToTradeText = shouldAcceptTrade ? translationForAcceptTrade : translationForRejectTrade;
        return this.ongoingTradeExists ? respondToTradeText : notYourTurnText;
    }
    destroy() {
        var _this_guideTextView;
        this.uiGameManager.eventController.unregisterUIGameMechanic(this);
        this.hide();
        this.guideBubbleView.destroy();
        this.guideBubbleViewPointer.destroy();
        (_this_guideTextView = this.guideTextView) === null || _this_guideTextView === void 0 ? void 0 : _this_guideTextView.destroy();
    }
    constructor(uiGameManager, viewToPlaceNear){
        this.backgroundClickAmount = 0;
        this.BACKGROUND_CLICK_AMOUNT_TO_SHOW_GUIDE = 2;
        this.ongoingTradeExists = false;
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.parentContainer = viewToPlaceNear.parent;
        this.drawBeginnerModeGuideBubble(viewToPlaceNear);
        this.hide();
    }
}
